import { IPreviewStatsReportWidget, } from 'atlas-shared';
import { IStatsReportWidgetStore, StatsReportWidgetActions, TStatsReportWidgetActionTypes, } from '@Store';

export const StatsReportWidgetReducer = (state: IStatsReportWidgetStore = {
  loaded: false,
  loading: false,
  stats_report_widgets: [],
  dict: {},
}, action: TStatsReportWidgetActionTypes): IStatsReportWidgetStore => {
  switch (action.type) {
  case StatsReportWidgetActions.LOADING:
    return { ...state, loading: true, };
  case StatsReportWidgetActions.SET_STATE:
    const dict: IStatsReportWidgetStore['dict'] = {};

    action.payload.forEach((stats_report_widget: IPreviewStatsReportWidget) => dict[stats_report_widget.id] = stats_report_widget);

    return { ...state, loaded: true, loading: false, stats_report_widgets: action.payload, dict, };
  case StatsReportWidgetActions.ADD_STATE:
    return { ...state, stats_report_widgets: [...state.stats_report_widgets, action.payload, ], dict: { ...state.dict, [action.payload.id]: action.payload, }, };
  case StatsReportWidgetActions.REMOVE_STATE: {

    const { [action.payload]: _deleted, ...dict } = state.dict;

    return { ...state, stats_report_widgets: state.stats_report_widgets.filter((item: IPreviewStatsReportWidget) => item.id !== action.payload), dict, };
  }
  case StatsReportWidgetActions.UPDATE_STATE:
    const stats_report_widgets = [...state.stats_report_widgets, ];
    const index = state.stats_report_widgets.findIndex((stats_report_widget: IPreviewStatsReportWidget) => stats_report_widget.id === action.payload.id);

    if (!~index)
      stats_report_widgets.push(action.payload);
    else
      stats_report_widgets[index] = action.payload;

    return { ...state, stats_report_widgets, dict: { ...state.dict, [action.payload.id]: action.payload, }, };
  default:
    return state;
  }
};
